/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e=require("prop-types"),s=o=>o.replace(/^k-i-/,""),t=o=>"k-i-"+o,n=e.shape({name:e.string.isRequired,content:e.string.isRequired,viewBox:e.string.isRequired});exports.svgIconPropType=n;exports.toIconClass=t;exports.toIconName=s;
